import {PAPAYA_VIEW_MODE} from '../../../dashboard/symbols/papaya.symbols';
import {DashboardStudyViewerMode} from '../../symbols';

/** Describes the state of the dashboard study viewer. */
export interface DashboardStudyViewerStateModel {
  isPapayaRendered: boolean;

  currentStudyViewerMode: DashboardStudyViewerMode;

  papayaController: any;
}

/** Default values for dashboard study viewer state initialization and reset. */
export const dashboardStudyViewerStateDefaults: DashboardStudyViewerStateModel = {
  isPapayaRendered: false,
  currentStudyViewerMode: null,
  papayaController: null,
};
